import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt, faPlus } from '@fortawesome/free-solid-svg-icons';
import { baseUrl } from '../components/constant';
import { toast } from 'react-toastify';
import { jsPDF } from 'jspdf';
const Users = () => {
  const [Images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [PersonalModal, setPersonalModal] = useState(false);
  const [CompanyModal, setCompanyModal] = useState(false);

  const [categoryToDelete, setCategoryToDelete] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [Users, setUsers] = useState([]);
  const [UserObj, setUserObj] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();
  const handleSearch = (event) => {
    setSearchQuery(event.target.value); // Update search query on text input change
  };
  
  const fetchUsers = async () => {
    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem('token'));
      console.log("baseUrl", baseUrl)
      const response = await fetch(`https://dashboard.onyxen-regalia.com/backend/api/admin/users`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        console.log("data", data)
        setUsers(data.users); // Adjust based on your API response structure
      } else {
        toast.error('Failed to fetch Ads');
      }
    } catch (err) {
      setError('Failed to fetch Ads');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);


  const handleDeleteClick = (user) => {
    console.log("user", user)
    setCategoryToDelete(user);
    setShowModal(true);
  };


  const HandleBlock = async (user) => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('user_id', user.id);
      formData.append('is_blocked', user.is_blocked == '1' ? '0' : '1');
      console.log("formData", formData)
      const token = JSON.parse(localStorage.getItem('token'));
      const response = await fetch(`${baseUrl}/user/block`, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        toast.success('change status successfully!');
        setShowModal(false); // Close the modal after successful deletion
        fetchUsers()

      } else {
        toast.error('Failed to disable package');
      }
    } catch (err) {
      toast.error('An error occurred while disable the package.');
    } finally {
      setLoading(false);
    }
  };
  const confirmDelete = async () => {
    if (!categoryToDelete) return;

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('user_id', categoryToDelete.id);
      formData.append('is_verified', categoryToDelete.is_verified == '1' ? '0' : '1');
      console.log("formData", formData)
      const token = JSON.parse(localStorage.getItem('token'));
      const response = await fetch(`${baseUrl}/user/verify`, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        toast.success('change status successfully!');
        setShowModal(false); // Close the modal after successful deletion
        fetchUsers()

      } else {
        toast.error('Failed to disable package');
      }
    } catch (err) {
      toast.error('An error occurred while disable the package.');
    } finally {
      setLoading(false);
    }
  };

  const cancelDelete = () => {
    setShowModal(false);
    setCategoryToDelete(null);
  };



  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < lastPage) {
      setCurrentPage(currentPage + 1);
    }
  };
  const HandleShowData = (user) => {
    setPersonalModal(true)
    setUserObj(user)
  }
  const HandleShowCompnayData = (user) => {
    setCompanyModal(true)
    setUserObj(user)
  }
  const generatePDF = (user) => {
    const doc = new jsPDF();
    const margin = 10;
    let yPosition = 20;
  
    // Set font size for the text
    doc.setFontSize(16);
  
    // Add user details to the PDF
    const userDetails = [
      `Name: ${user.name}`,
      `Email: ${user.email}`,
      `Phone: ${user.phone_code} ${user.phone_number}`,
      `National ID or Passport Number: ${user.passport}`,
      `ID: ${user.id}`,
    ];
  
    userDetails.forEach((line) => {
      const wrappedText = doc.splitTextToSize(line, 180); // 180 is the max width in mm
      wrappedText.forEach((textLine) => {
        doc.text(textLine, margin, yPosition);
        yPosition += 10;
      });
    });
  
    // Function to load and add image to the PDF
    const addImageWithTitle = (imageUrl, title) => {
      const image = new Image();
      image.src = imageUrl;
      return new Promise((resolve) => {
        image.onload = () => {
          // Add the title above the image
          doc.setFontSize(14);
          doc.text(title, margin, yPosition);
          yPosition += 10;  // Adjust yPosition after the title
  
          // Add the image to the PDF
          doc.addImage(image, 'JPEG', margin, yPosition, 40, 40); // Adjust size and position as needed
          yPosition += 45; // Adjust yPosition after the image
          resolve();  // Resolve the promise after the image is added
        };
      });
    };
  
    // Create an array of promises for all images
    const imagePromises = [];
  
    // Add Profile Image if available
    if (user.profile_image) {
      const profileUrl = `https://dashboard.onyxen-regalia.com/backend/storage/${user.profile_image}`;
      imagePromises.push(addImageWithTitle(profileUrl, 'Profile Image'));
    }
  
    // Add Passport Image if available
    if (user.passport_image) {
      const passportUrl = `https://dashboard.onyxen-regalia.com/backend/storage/${user.passport_image}`;
      imagePromises.push(addImageWithTitle(passportUrl, 'Passport Image'));
    }
  
    // Add Back ID Image if available
    if (user.BackId) {
      const backIdUrl = `https://dashboard.onyxen-regalia.com/backend/storage/${user.BackId}`;
      imagePromises.push(addImageWithTitle(backIdUrl, 'Back ID Image'));
    }
  
    // Wait for all images to load and be added to the PDF
    Promise.all(imagePromises).then(() => {
      // After all images and text are added, save the PDF
      doc.save(`${user.name}_profile.pdf`);
    });
  };
  
  // const generatePDF = (user) => {
  //   const doc = new jsPDF();
  //   const margin = 10;
  //   let yPosition = 20;
  
  //   // Set font size for the text
  //   doc.setFontSize(16);
  
  //   // Add user details to the PDF
  //   const userDetails = [
  //     `Name: ${user.name}`,
  //     `Email: ${user.email}`,
  //     `Phone: ${user.phone_code} ${user.phone_number}`,
  //     `National ID or Passport Number: ${user.passport}`,
  //     `ID: ${user.id}`,
  //   ];
  
  //   userDetails.forEach((line) => {
  //     const wrappedText = doc.splitTextToSize(line, 180); // 180 is the max width in mm
  //     wrappedText.forEach((textLine) => {
  //       doc.text(textLine, margin, yPosition);
  //       yPosition += 10;
  //     });
  //   });
  
  //   // Add profile image if available
  //   if (user.profile_image) {
  //     const profileUrl = `https://dashboard.onyxen-regalia.com/backend/storage/${user.profile_image}`;
      
  //     // Load the image from the URL and add it to the PDF
  //     const image = new Image();
  //     image.src = profileUrl;
  //     image.onload = () => {
  //       doc.addImage(image, 'JPEG', margin, yPosition, 40, 40); // Adjust size and position as needed
  //       yPosition += 45; // Adjust position after adding image
  //       doc.save(`${user.name}_profile.pdf`); // Save PDF once the image is loaded
  //     };
  //   }
  
  //   // Add passport image if available
  //   if (user.passport_image) {
  //     const passportUrl = `https://dashboard.onyxen-regalia.com/backend/storage/${user.passport_image}`;
      
  //     const passportImage = new Image();
  //     passportImage.src = passportUrl;
  //     passportImage.onload = () => {
  //       doc.addImage(passportImage, 'JPEG', margin, yPosition, 40, 40); // Adjust size and position as needed
  //       yPosition += 45;
  //       doc.save(`${user.name}_profile.pdf`);
  //     };
  //   }
  
  //   // Add back ID image if available
  //   if (user.BackId) {
  //     const backIdUrl = `https://dashboard.onyxen-regalia.com/backend/storage/${user.BackId}`;
      
  //     const backIdImage = new Image();
  //     backIdImage.src = backIdUrl;
  //     backIdImage.onload = () => {
  //       doc.addImage(backIdImage, 'JPEG', margin, yPosition, 40, 40); // Adjust size and position as needed
  //       yPosition += 45;
  //       doc.save(`${user.name}_profile.pdf`);
  //     };
  //   }
  // };
  
  const generateCompanyPDF = (user) => {
    const doc = new jsPDF();
    const margin = 10;
    let yPosition = 20;
  
    // Set font size for the text
    doc.setFontSize(16);
  
    // Add user details to the PDF
    const userDetails = [
      `Name: ${user.name}`,
      `Email: ${user.email}`,
      `Phone: ${user.phone_code} ${user.phone_number}`,
      `National ID or Passport Number: ${user.passport}`,
      `ID: ${user.id}`,
    ];
  
    userDetails.forEach((line) => {
      const wrappedText = doc.splitTextToSize(line, 180); // 180 is the max width in mm
      wrappedText.forEach((textLine) => {
        doc.text(textLine, margin, yPosition);
        yPosition += 10;
      });
    });
  
    // Function to load and add image to the PDF
    const addImageToPDF = (imageUrl, title) => {
      const image = new Image();
      image.src = imageUrl;
      return new Promise((resolve) => {
        image.onload = () => {
          // Add the title above the image
          doc.setFontSize(14);
          doc.text(title, margin, yPosition);
          yPosition += 10;  // Adjust yPosition after the title
  
          // Add the image to the PDF
          doc.addImage(image, 'JPEG', margin, yPosition, 40, 40); // Adjust size and position as needed
          yPosition += 45; // Adjust yPosition after the image
          resolve();  // Resolve the promise after the image is added
        };
      });
    };
  
    // Create an array of promises for all images
    const imagePromises = [];
  
    // Add Profile Image if available
    if (user.profile_image) {
      const profileUrl = `https://dashboard.onyxen-regalia.com/backend/storage/${user.profile_image}`;
      imagePromises.push(addImageToPDF(profileUrl, 'Profile Image'));
    }
  
    // Add Business License Image if available
    if (user.business_license) {
      const businessLicenseUrl = `https://dashboard.onyxen-regalia.com/backend/storage/${user.business_license}`;
      imagePromises.push(addImageToPDF(businessLicenseUrl, 'Commercial License'));
    }
  
    // Add Commercial Registration Image if available
    if (user.commercial_registration) {
      const commercialRegistrationUrl = `https://dashboard.onyxen-regalia.com/backend/storage/${user.commercial_registration}`;
      imagePromises.push(addImageToPDF(commercialRegistrationUrl, 'Commercial Register'));
    }
  
    // Add Owner or Authorized Signatory Card Image if available
    if (user.owner_or_authorized_signatory_id) {
      const ownerSignatoryUrl = `https://dashboard.onyxen-regalia.com/backend/storage/${user.owner_or_authorized_signatory_id}`;
      imagePromises.push(addImageToPDF(ownerSignatoryUrl, 'Owner or Authorized Signatory’s Card'));
    }
  
    // Add Establishment Record Image if available
    if (user.establishment_record) {
      const establishmentRecordUrl = `https://dashboard.onyxen-regalia.com/backend/storage/${user.establishment_record}`;
      imagePromises.push(addImageToPDF(establishmentRecordUrl, 'Business Registration'));
    }
  
    // Add Other Image if available
    if (user.other) {
      const otherImageUrl = `https://dashboard.onyxen-regalia.com/backend/storage/${user.other}`;
      imagePromises.push(addImageToPDF(otherImageUrl, 'Other Image'));
    }
  
    // Wait for all images to load and be added to the PDF
    Promise.all(imagePromises).then(() => {
      // After all images and text are added, save the PDF
      doc.save(`${user.name}_profile.pdf`);
    });
  };
  

  // const generateCompanyPDF = (user) => {
  //   const doc = new jsPDF();
  //   const margin = 10;
  //   let yPosition = 20;
  
  //   // Set font size for the text
  //   doc.setFontSize(16);
  
  //   // Add user details to the PDF
  //   const userDetails = [
  //     `Name: ${user.name}`,
  //     `Email: ${user.email}`,
  //     `Phone: ${user.phone_code} ${user.phone_number}`,
  //     `National ID or Passport Number: ${user.passport}`,
  //     `ID: ${user.id}`,
  //   ];
  
  //   userDetails.forEach((line) => {
  //     const wrappedText = doc.splitTextToSize(line, 180); // 180 is the max width in mm
  //     wrappedText.forEach((textLine) => {
  //       doc.text(textLine, margin, yPosition);
  //       yPosition += 10;
  //     });
  //   });
  
  //   // Function to load and add image to the PDF
  //   const addImageToPDF = (imageUrl, title) => {
  //     const image = new Image();
  //     image.src = imageUrl;
  //     image.onload = () => {
  //       // Add the title above the image
  //       doc.setFontSize(14);
  //       doc.text(title, margin, yPosition);
  //       yPosition += 10;  // Adjust yPosition after the title
  
  //       // Add the image to the PDF
  //       doc.addImage(image, 'JPEG', margin, yPosition, 40, 40); // Adjust size and position as needed
  //       yPosition += 45; // Adjust yPosition after the image
  //       doc.save(`${user.name}_profile.pdf`); // Save the PDF once the image is loaded
  //     };
  //   };
  
  //   // Add Profile Image if available
  //   if (user.profile_image) {
  //     const profileUrl = `https://dashboard.onyxen-regalia.com/backend/storage/${user.profile_image}`;
  //     addImageToPDF(profileUrl, 'Profile Image');
  //   }
  
  //   // Add Business License Image if available
  //   if (user.business_license) {
  //     const businessLicenseUrl = `https://dashboard.onyxen-regalia.com/backend/storage/${user.business_license}`;
  //     addImageToPDF(businessLicenseUrl, 'Commercial License');
  //   }
  
  //   // Add Commercial Registration Image if available
  //   if (user.commercial_registration) {
  //     const commercialRegistrationUrl = `https://dashboard.onyxen-regalia.com/backend/storage/${user.commercial_registration}`;
  //     addImageToPDF(commercialRegistrationUrl, 'Commercial Register');
  //   }
  
  //   // Add Owner or Authorized Signatory Card Image if available
  //   if (user.owner_or_authorized_signatory_id) {
  //     const ownerSignatoryUrl = `https://dashboard.onyxen-regalia.com/backend/storage/${user.owner_or_authorized_signatory_id}`;
  //     addImageToPDF(ownerSignatoryUrl, 'Owner or Authorized Signatory’s Card');
  //   }
  
  //   // Add Establishment Record Image if available
  //   if (user.establishment_record) {
  //     const establishmentRecordUrl = `https://dashboard.onyxen-regalia.com/backend/storage/${user.establishment_record}`;
  //     addImageToPDF(establishmentRecordUrl, 'Business Registration');
  //   }
  
  //   // Add Other Image if available
  //   if (user.other) {
  //     const otherImageUrl = `https://dashboard.onyxen-regalia.com/backend/storage/${user.other}`;
  //     addImageToPDF(otherImageUrl, 'Other Image');
  //   }
  // };
  
  // const generateCompanyPDF = (user) => {
  //   const doc = new jsPDF();
  //   const margin = 10;
  //   let yPosition = 20;
  
  //   // Set font size for the text
  //   doc.setFontSize(16);
  
  //   // Add user details to the PDF
  //   const userDetails = [
  //     `Name: ${user.name}`,
  //     `Email: ${user.email}`,
  //     `Phone: ${user.phone_code} ${user.phone_number}`,
  //     `National ID or Passport Number: ${user.passport}`,
  //     `ID: ${user.id}`,
  //   ];
  
  //   userDetails.forEach((line) => {
  //     const wrappedText = doc.splitTextToSize(line, 180); // 180 is the max width in mm
  //     wrappedText.forEach((textLine) => {
  //       doc.text(textLine, margin, yPosition);
  //       yPosition += 10;
  //     });
  //   });
  
  //   // Add image URLs if available
  //   if (user.profile_image) {
  //     const profileUrl = `https://dashboard.onyxen-regalia.com/backend/storage/${user.profile_image}`;
  //     const wrappedProfileUrl = doc.splitTextToSize(`Profile Image: ${profileUrl}`, 180);
  //     wrappedProfileUrl.forEach((textLine) => {
  //       doc.text(textLine, margin, yPosition);
  //       yPosition += 10;
  //     });
  //   }
  
  //   if (user.business_license) {
  //     const passportUrl = `https://dashboard.onyxen-regalia.com/backend/storage/${user.business_license}`;
  //     const wrappedPassportUrl = doc.splitTextToSize(`Commercial License: ${passportUrl}`, 180);
  //     wrappedPassportUrl.forEach((textLine) => {
  //       doc.text(textLine, margin, yPosition);
  //       yPosition += 10;
  //     });
  //   }
  
  //   if (user.commercial_registration) {
  //     const backIdUrl = `https://dashboard.onyxen-regalia.com/backend/storage/${user.commercial_registration}`;
  //     const wrappedBackIdUrl = doc.splitTextToSize(`Commercial Register: ${backIdUrl}`, 180);
  //     wrappedBackIdUrl.forEach((textLine) => {
  //       doc.text(textLine, margin, yPosition);
  //       yPosition += 10;
  //     });
  //   }

  //   if (user.owner_or_authorized_signatory_id) {
  //     const backIdUrl = `https://dashboard.onyxen-regalia.com/backend/storage/${user.owner_or_authorized_signatory_id}`;
  //     const wrappedBackIdUrl = doc.splitTextToSize(`Owner or Authorized Signatory’s Card: ${backIdUrl}`, 180);
  //     wrappedBackIdUrl.forEach((textLine) => {
  //       doc.text(textLine, margin, yPosition);
  //       yPosition += 10;
  //     });
  //   }

  //   if (user.establishment_record) {
  //     const backIdUrl = `https://dashboard.onyxen-regalia.com/backend/storage/${user.establishment_record}`;
  //     const wrappedBackIdUrl = doc.splitTextToSize(`Business Registration: ${backIdUrl}`, 180);
  //     wrappedBackIdUrl.forEach((textLine) => {
  //       doc.text(textLine, margin, yPosition);
  //       yPosition += 10;
  //     });
  //   }

  //   if (user.other) {
  //     const backIdUrl = `https://dashboard.onyxen-regalia.com/backend/storage/${user.other}`;
  //     const wrappedBackIdUrl = doc.splitTextToSize(`Other image: ${backIdUrl}`, 180);
  //     wrappedBackIdUrl.forEach((textLine) => {
  //       doc.text(textLine, margin, yPosition);
  //       yPosition += 10;
  //     });
  //   }
  
  //   // Save the PDF with the user's name
  //   doc.save(`${user.name}_profile.pdf`);
  // };
  const filteredUsers = searchQuery
  ? Users.filter(user => 
      user.name && user.name.toLowerCase().includes(searchQuery.toLowerCase()) // Check if user.name is valid before calling toLowerCase
    )
  : Users;
  return (
    <div className="dashboard">
    <div className="search-container" style={{width: '100%', display: 'flex', justifyContent: 'center', marginBottom: '20px'}}>
        <input 
        style={{width:"90%",height:"40px",borderRadius:"5px",padding:"10px",backgroundColor:"white",border:"2px solid #ccc",color:"#000"}}
          type="text" 
          placeholder="Search by user name" 
          value={searchQuery}
          onChange={handleSearch} // Handle input change
        />
      </div>
      <div className="category-list">
        {loading && (
          <div className="loader-overlay">
            <div className="loader"></div>
          </div>
        )}


        {!loading && filteredUsers.map(user => (
          <div key={user.id} className="category-item">


            <div className="category-row">
              <span className="category-id">ID: {user.id}</span>
              {user.profile_image ?
                <img src={'https://dashboard.onyxen-regalia.com/backend/storage/' + user.profile_image} alt='profile' className="category-image" />
                :
                <img src='profile-circle.png' alt='profile' className="category-image" />

              }

              <div style={{ flexGrow: 1 }}>
                <h3 className="category-name" style={{ color: "rgb(154, 57, 57)" }}>{user.name}</h3>
                <h3 className="category-name" style={{ color: "rgb(154, 57, 57)" }}>{user.phone_code}{user.phone_number}</h3>
                {user.is_admin == '1' ?
                  <h3 className="category-name" style={{ color: "rgb(154, 57, 57)" }}>Admin</h3>
                  :
                  <></>
                }
              </div>

              <div className="buttons">
                {user.is_admin == '0' ?
                  <button className="delete" style={{ color: user.is_verified ? 'red' : 'green' }} onClick={() => handleDeleteClick(user)}>
                    {user.is_verified == '1' ?
                      <p style={{ color: user.is_verified ? 'red' : 'green' }}>unverfiy</p>
                      :
                      <p>verfiy</p>
                    }
                  </button>
                  :
                  <></>
                }

                {user.is_personal == '1' ?
                  <button className="delete" style={{ color: 'green' }} onClick={() => HandleShowData(user)}>
                    <p style={{ color: user.is_verified ? 'red' : 'green' }}>Show Data</p>
                  </button>
                  :
                  <></>
                }
                {user.is_personal == '0' ?
                  <button className="delete" style={{ color: 'green' }} onClick={() => HandleShowCompnayData(user)}>
                    <p style={{ color: user.is_verified ? 'red' : 'green' }}>Show Data</p>
                  </button>
                  :
                  <></>
                }

                {user.id == '1' ?
                  <></>
                :
                  <button className="delete" style={{ color: 'green' }} onClick={() => HandleBlock(user)}>
                    {user.is_blocked == '1' ?
                      <p style={{ color: 'green' }}>UnBlock</p>
                      :
                      <p style={{ color: 'red' }}>Block</p>

                    }
                  </button>
                }

<button style={{color:"#000"}} onClick={() => user.is_personal == '0' ? generateCompanyPDF(user): generatePDF(user)}>Download PDF</button>

              </div>
            </div>
          </div>
        ))}
      </div>

      {lastPage > 1 &&

        <div className="pagination-controls">
          <button
            onClick={handlePreviousPage}
            disabled={currentPage === 1}
            style={{ marginRight: '10px', backgroundColor: 'rgb(154, 57, 57)', color: '#fff' }}
          >
            Previous
          </button>
          <span>Page {currentPage} of {lastPage}</span>
          <button
            onClick={handleNextPage}
            disabled={currentPage === lastPage}
            style={{ marginLeft: '10px', backgroundColor: 'rgb(154, 57, 57)', color: '#fff' }}
          >
            Next
          </button>
        </div>
      }

      {showModal && (
        <div className="modal show">
          <div className="modal-content">
            <h3 style={{ color: '#000' }}>Are you sure you want to change status of this user?</h3>
            <button className="cancel-button" onClick={cancelDelete} style={{ backgroundColor: "#000" }}>Cancel</button>
            <button className="delete-button" onClick={confirmDelete} style={{ backgroundColor: 'rgb(154, 57, 57)' }}>Change</button>
          </div>
        </div>
      )}

      {PersonalModal && (
        <div className="modal show">
          <div className="modal-content">
            <p style={{ color: '#000' }}>national ID number or passport number : {UserObj.passport}</p>
            <div>
              <p style={{ color: '#000' }}>Identification card or passport</p>

              {UserObj.passport_image ?
                <a href={'https://dashboard.onyxen-regalia.com/backend/storage/' + UserObj.passport_image} target="_blank" rel="noopener noreferrer">
                  <img src={'https://dashboard.onyxen-regalia.com/backend/storage/' + UserObj.passport_image} alt='profile' className="category-image" />
                </a>
                :
                <img src='profile-circle.png' alt='profile' className="category-image" />
              }
            </div>
            <div>
              <p style={{ color: '#000' }}>Identification card or passport (Back side)</p>

              {UserObj.BackId ?
                <a href={'https://dashboard.onyxen-regalia.com/backend/storage/' + UserObj.BackId} target="_blank" rel="noopener noreferrer">

                  <img src={'https://dashboard.onyxen-regalia.com/backend/storage/' + UserObj.BackId} alt='profile' className="category-image" />
                </a>
                :
                <img src='profile-circle.png' alt='profile' className="category-image" />
              }
            </div>
            <button className="delete-button" onClick={() => setPersonalModal(false)} style={{ backgroundColor: 'rgb(13, 13, 13)', marginTop: 20 }}>Close</button>

          </div>
        </div>
      )}
      {CompanyModal && (
        <div className="modal show" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1000, }}>
          <div className="modal-content" style={{ width: '90%', maxHeight: '80vh', overflowY: 'auto', padding: '20px', backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' ,maxWidth:'600px'}}>
            <p style={{ color: '#000' }}>National ID number or passport number: {UserObj.passport}</p>

            {/* Wrapper for all the image sections */}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px' }}>

              <div style={{ flex: '1 1 45%' }}>
                <p style={{ color: '#000' }}>Commercial License</p>
                <div style={{ border: '2px solid #535353', borderRadius: '8px', padding: '10px' }}>
                  {UserObj.business_license ?
                    <a href={'https://dashboard.onyxen-regalia.com/backend/storage/' + UserObj.business_license} target="_blank" rel="noopener noreferrer">
                      <img src={'https://dashboard.onyxen-regalia.com/backend/storage/' + UserObj.business_license} alt='Commercial License' style={{ width: '100%', height: '200px', borderRadius: '4px' }} />
                    </a>
                    :
                    <img src='profile-circle.png' alt='profile' className="category-image" style={{ width: '100%', height: '200px', borderRadius: '4px' }} />
                  }
                </div>
              </div>

              <div style={{ flex: '1 1 45%' }}>
                <p style={{ color: '#000' }}>Commercial Register</p>
                <div style={{ border: '2px solid #535353', borderRadius: '8px', padding: '10px' }}>
                  {UserObj.commercial_registration ?
                    <a href={'https://dashboard.onyxen-regalia.com/backend/storage/' + UserObj.commercial_registration} target="_blank" rel="noopener noreferrer">
                      <img src={'https://dashboard.onyxen-regalia.com/backend/storage/' + UserObj.commercial_registration} alt='Commercial Register' style={{ width: '100%', height: '200px', borderRadius: '4px' }} />
                    </a>
                    :
                    <img src='profile-circle.png' alt='profile' className="category-image" style={{ width: '100%', height: '200px', borderRadius: '4px' }} />
                  }
                </div>
              </div>

              <div style={{ flex: '1 1 45%' }}>
                <p style={{ color: '#000' }}>Owner or Authorized Signatory’s Card</p>
                <div style={{ border: '2px solid #535353', borderRadius: '8px', padding: '10px' }}>
                  {UserObj.owner_or_authorized_signatory_id ?
                    <a href={'https://dashboard.onyxen-regalia.com/backend/storage/' + UserObj.owner_or_authorized_signatory_id} target="_blank" rel="noopener noreferrer">
                      <img src={'https://dashboard.onyxen-regalia.com/backend/storage/' + UserObj.owner_or_authorized_signatory_id} alt='Owner or Authorized' style={{ width: '100%', height: '200px', borderRadius: '4px' }} />
                    </a>
                    :
                    <img src='profile-circle.png' alt='profile' className="category-image" style={{ width: '100%', height: '200px', borderRadius: '4px' }} />
                  }
                </div>
              </div>

              <div style={{ flex: '1 1 45%' }}>
                <p style={{ color: '#000' }}>Business Registration</p>
                <div style={{ border: '2px solid #535353', borderRadius: '8px', padding: '10px' }}>
                  {UserObj.establishment_record ?
                    <a href={'https://dashboard.onyxen-regalia.com/backend/storage/' + UserObj.establishment_record} target="_blank" rel="noopener noreferrer">
                      <img src={'https://dashboard.onyxen-regalia.com/backend/storage/' + UserObj.establishment_record} alt='Business Registration' style={{ width: '100%', height: '200px', borderRadius: '4px' }} />
                    </a>
                    :
                    <img src='profile-circle.png' alt='profile' className="category-image" style={{ width: '100%', height: '200px', borderRadius: '4px' }} />
                  }
                </div>
              </div>

              <div style={{ flex: '1 1 45%' }}>
                <p style={{ color: '#000' }}>Other</p>
                <div style={{ border: '2px solid #535353', borderRadius: '8px', padding: '10px' }}>
                  {UserObj.other ?
                    <a href={'https://dashboard.onyxen-regalia.com/backend/storage/' + UserObj.other} target="_blank" rel="noopener noreferrer">
                      <img src={'https://dashboard.onyxen-regalia.com/backend/storage/' + UserObj.other} alt='Other' style={{ width: '100%', height: '200px', borderRadius: '4px' }} />
                    </a>
                    :
                    <img src='profile-circle.png' alt='profile' className="category-image" style={{ width: '100%', height: '200px', borderRadius: '4px' }} />
                  }
                </div>
              </div>

            </div>

            <button className="delete-button" onClick={() => setCompanyModal(false)} style={{ backgroundColor: 'rgb(13, 13, 13)', marginTop: '20px', color: '#fff', padding: '10px 20px', border: 'none', borderRadius: '4px' }}>
              Close
            </button>
          </div>
        </div>
      )}


      {/* {CompanyModal && (
        <div className="modal show">
           <div className="modal-content">
            <p style={{ color: '#000' }}>national ID number or passport number : {UserObj.passport}</p>
            <div>
              <p style={{ color: '#000' }}>Commercial License</p>

              {UserObj.business_license ?
                <a href={'https://dashboard.onyxen-regalia.com/backend/storage/' + UserObj.business_license} target="_blank" rel="noopener noreferrer">
                  <img src={'https://dashboard.onyxen-regalia.com/backend/storage/' + UserObj.business_license} alt='Commercial License'  />
                </a>
                :
                <img src='profile-circle.png' alt='profile' className="category-image" />
              }
            </div>
            <div>
              <p style={{ color: '#000' }}>Commercial Register</p>
              {UserObj.commercial_registration ?
                <a href={'https://dashboard.onyxen-regalia.com/backend/storage/' + UserObj.commercial_registration} target="_blank" rel="noopener noreferrer">

                  <img src={'https://dashboard.onyxen-regalia.com/backend/storage/' + UserObj.commercial_registration} alt='Commercial Register' className="category-image" />
                </a>
                :
                <img src='profile-circle.png' alt='profile' className="category-image" />
              }
            </div>

            <div>
              <p style={{ color: '#000' }}>Owner or Authorized Signatory’s Card</p>
              {UserObj.owner_or_authorized_signatory_id ?
                <a href={'https://dashboard.onyxen-regalia.com/backend/storage/' + UserObj.owner_or_authorized_signatory_id} target="_blank" rel="noopener noreferrer">

                  <img src={'https://dashboard.onyxen-regalia.com/backend/storage/' + UserObj.owner_or_authorized_signatory_id} alt='Owner or Authorized' className="category-image" />
                </a>
                :
                <img src='profile-circle.png' alt='profile' className="category-image" />
              }
            </div>


            <div>
            <p style={{ color: '#000' }}>Business Registration</p>
              {UserObj.establishment_record ?
                <a href={'https://dashboard.onyxen-regalia.com/backend/storage/' + UserObj.establishment_record} target="_blank" rel="noopener noreferrer">

                  <img src={'https://dashboard.onyxen-regalia.com/backend/storage/' + UserObj.establishment_record} alt='Business Registration' className="category-image" />
                </a>
                :
                <img src='profile-circle.png' alt='profile' className="category-image" />
              }
            </div>




            <div>
            <p style={{ color: '#000' }}>Other</p>
              {UserObj.other ?
                <a href={'https://dashboard.onyxen-regalia.com/backend/storage/' + UserObj.other} target="_blank" rel="noopener noreferrer">

                  <img src={'https://dashboard.onyxen-regalia.com/backend/storage/' + UserObj.other} alt='other' className="category-image" />
                </a>
                :
                <img src='profile-circle.png' alt='profile' className="category-image" />
              }
            </div>

            <button className="delete-button" onClick={() => setPersonalModal(false)} style={{ backgroundColor: 'rgb(13, 13, 13)', marginTop: 20 }}>Close</button>

          </div>
        </div>
      )} */}
    </div>
  );
};

export default Users;
